import { cn } from "@repo/ui/lib/utils";
import { IconLoadingCircle } from "central-icons/IconLoadingCircle";

export function Spinner({
  color = "hsl(198 9% 48%)",
  className,
  size = 24,
}: {
  color?: string;
  size?: number;
  className?: string;
}) {
  return (
    <div className="flex items-center flex-col justify-center">
      <IconLoadingCircle
        className={cn("animate-spin", className)}
        color={color}
        size={size}
      />
    </div>
  );
}

